import { sendEmail } from '../../lib/api/send-email'
import { SendEmailInput } from '../../lib/types/models/mail/create-mail-attachment'
import { API } from '../apis.config'

export const sendEmailToHostFamilies = (input: SendEmailInput) => {
  return sendEmail(API.hostFamilies.sendEmailToHostFamilies.url, input)
}
